import React from 'react';
import { DEFAULT_PAGE_SIZE, fetchAuditEvents } from '@services/fmdc';
import { ACTOR_TYPE_FILTERS } from './fmdcUrl';

// One page of audit events for the URL's filters. Same shape as useCatalogItems.
export const useAuditEvents = (filters) => {
  const [events, setEvents] = React.useState(null);
  const [total, setTotal] = React.useState(0);
  const [error, setError] = React.useState(null);
  const [tick, setTick] = React.useState(0);

  const { runId, eventType, actorType, from, to, offset } = filters;

  React.useEffect(() => {
    const state = { isCanceled: false };
    const run = async () => {
      const result = await fetchAuditEvents({
        runId: runId || undefined,
        eventType: eventType || undefined,
        actorType: actorType === ACTOR_TYPE_FILTERS.ALL ? undefined : actorType,
        from: from || undefined,
        to: to || undefined,
        limit: DEFAULT_PAGE_SIZE,
        offset,
      });
      if (state.isCanceled) return;
      if (result.error) {
        setError(result.error);
        setEvents((prev) => prev || []);
      } else {
        setError(null);
        setEvents(result.events);
        setTotal(result.total);
      }
    };
    run();
    return () => {
      state.isCanceled = true;
    };
  }, [runId, eventType, actorType, from, to, offset, tick]);

  const reload = React.useCallback(() => setTick((t) => t + 1), []);

  return { events, total, isLoading: events === null, error, reload };
};
